(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["whatsapp-split-widget"]) return;
  try {
    
  const normalizeWhatsAppNumber = (value) => {
    const digits = String(value || '').replace(/\D/g, '');
    return digits.startsWith('0') ? `972${digits.slice(1)}` : digits;
  };

  document.querySelectorAll('[data-whatsapp-split-widget]').forEach((widget) => {
    if (widget.dataset.initialized === 'true') return;
    widget.dataset.initialized = 'true';

    const link = widget.querySelector('a');
    const primaryNumber = normalizeWhatsAppNumber(widget.dataset.primaryNumber);
    const alternateNumber = normalizeWhatsAppNumber(widget.dataset.alternateNumber);
    const alternateEvery = Math.max(2, Number.parseInt(widget.dataset.alternateEvery, 10) || 5);
    const message = widget.dataset.message || '';
    link.addEventListener('click', () => {
      const selectedNumber = Math.random() < 1 / alternateEvery ? alternateNumber : primaryNumber;
      link.href = `https://wa.me/${selectedNumber}?text=${encodeURIComponent(message)}`;
    });
  });

  } catch(e) { console.error(e); }
})();
})();
